<template>
  <b-modal
    id="modal-roles"
    hide-footer
    hide-header
    centered
    :title="viewDetail ? 'View Role' : isEditing ? 'Edit Role' : 'Add New Role'"
    size="lg"
  >
    <div class="py-50">
      <h1 class="text-center">
        {{ viewDetail ? 'View Role' : isEditing ? 'Edit Role' : 'Add New Role' }}
      </h1>
      <h5 class="text-center">Set role permissions</h5>

      <b-row class="ml-2 mr-2 mt-1">
        <b-col class="p-0" md="12">
          <b-form-group label="Role Name">
            <b-form-input
              ref="name"
              v-model.trim="roleObj.name"
              placeholder="Enter role name"
              :disabled="viewDetail"
              @focusout="CheckRoleName"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <div class="scrollContent">
        <b-row class="m-1 mb-1">
          <b-col class="p-0" md="5">
            <!-- <h5 class="mb-0 d-flex justify-content-end">Select All</h5> -->
          </b-col>
          <b-col class="d-flex align-items-center flex-wrap" md="7">
            <b-form-checkbox
              @change="ToggleAll('view')"
              v-model="all.view"
              :disabled="viewDetail"
            /><span class="mr-1">View</span>
            <b-form-checkbox
              @change="ToggleAll('add')"
              v-model="all.add"
              :disabled="viewDetail"
            /><span class="mr-1">Add</span>
            <b-form-checkbox
              @change="ToggleAll('edit')"
              v-model="all.edit"
              :disabled="viewDetail"
            /><span class="mr-1">Edit</span>
            <b-form-checkbox
              @change="ToggleAll('delete')"
              v-model="all.delete"
              :disabled="viewDetail"
            /><span class="mr-1">Delete</span>
          </b-col>
        </b-row>

        <b-row
          class="m-1 mb-1"
          v-for="item in myObj"
          :key="item.id"
          v-if="item.children.length > 0"
        >
          <b-col class="p-0" md="12">
            <h4 class="font-weight-bolder mb-0">{{ item.name }}</h4>
          </b-col>
          <b-col v-for="(child, index) in item.children" :key="index" md="12">
            <b-row style="border-bottom: 1px solid lightgray" class="pt-1 pb-1">
              <b-col class="p-0" md="5">
                <h5 class="mb-0">{{ child.title }}</h5>
              </b-col>
              <b-col class="d-flex align-items-center flex-wrap" md="7">
                <b-form-checkbox v-model="child.view" :disabled="viewDetail"
                  ><span class="mr-1">View</span></b-form-checkbox
                >
                <b-form-checkbox v-model="child.add" :disabled="viewDetail"
                  ><span class="mr-1">Add</span></b-form-checkbox
                >
                <b-form-checkbox v-model="child.edit" :disabled="viewDetail"
                  ><span class="mr-1">Edit</span></b-form-checkbox
                >
                <b-form-checkbox v-model="child.delete" :disabled="viewDetail"
                  ><span class="mr-1">Delete</span></b-form-checkbox
                >
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>

      <b-row class="mt-1">
        <b-col md="12" class="text-right">
          <b-button v-if="viewDetail" variant="primary" @click="closeModal"> Close </b-button>
          <b-button v-else variant="success" @click="save" :disabled="request">
            <b-spinner v-if="request" small type="grow" />
            <span v-else>Save</span>
          </b-button>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
import { APIService } from '@/utils/api';
import { RESOURCES } from '@/utils/constants';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import {
  BButton,
  BCol,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BModal,
  BRow,
  BSpinner,
} from 'bootstrap-vue';

export default {
  name: 'RoleModal',
  components: {
    BModal,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BButton,
    BRow,
    BCol,
    BSpinner,
  },
  props: {
    isEditing: {
      type: Boolean,
      default: false,
    },
    viewDetail: {
      type: Boolean,
      default: false,
    },
    role: {
      type: Object,
      default: () => ({}),
    },
    businessID: {
      type: [Number, String],
      required: true,
    },
    userID: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      all: {
        view: false,
        add: false,
        edit: false,
        delete: false,
      },
      myObj: [],
      roleObj: {
        id: 0,
        businessID: 0,
        name: '',
        forms: '',
      },
      request: false,
    };
  },
  watch: {
    role: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          this.roleObj = { ...newVal };
          // Reset all checkboxes when role changes
          this.resetCheckboxes();
          // If editing, load the role's permissions
          if (this.isEditing && this.role.forms) {
            this.loadRolePermissions();
          }
        } else {
          // Reset form when adding new role
          this.resetForm();
        }
      },
      immediate: true,
    },
    isEditing: {
      handler(newVal) {
        if (!newVal) {
          // Reset everything when switching to add mode
          this.resetForm();
          this.resetCheckboxes();
          // Reload form data to get fresh state
          this.loadFormData();
        }
      },
      immediate: true,
    },
  },
  methods: {
    resetForm() {
      this.roleObj = {
        id: 0,
        businessID: this.businessID,
        name: '',
        forms: '',
      };
      this.resetCheckboxes();
    },

    resetCheckboxes() {
      this.all = {
        view: false,
        add: false,
        edit: false,
        delete: false,
      };
      if (this.myObj.length > 0) {
        this.myObj.forEach((group) => {
          if (group.children) {
            group.children.forEach((child) => {
              child.view = false;
              child.add = false;
              child.edit = false;
              child.delete = false;
            });
          }
        });
      }
    },

    async loadRolePermissions() {
      try {
        if (!this.role.forms) return;

        const currentFields = JSON.parse(this.role.forms);
        this.updatePermissionsFromCurrentFields(currentFields);
      } catch (error) {
        console.error('Error loading role permissions:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error',
            icon: 'AlertCircleIcon',
            variant: 'danger',
            text: 'Failed to load role permissions',
          },
        });
      }
    },

    async loadFormData() {
      try {
        this.request = true;
        const response = await APIService.loadData(RESOURCES.ROLES, this.businessID, this.userID);
        if (response?.data?.status === 'success') {
          // Create a fresh copy of the form data
          this.myObj = JSON.parse(JSON.stringify(response?.data?.data || []));

          // Reset all checkboxes in the fresh data
          this.resetCheckboxes();

          // If editing, load the role's permissions after getting form data
          if (this.isEditing && this.role.forms) {
            this.loadRolePermissions();
          }
        } else {
          this.myObj = [];
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error',
              icon: 'AlertCircleIcon',
              variant: 'danger',
              text: 'Failed to Load Forms',
            },
          });
        }
      } catch (error) {
        console.error('Error loading forms:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error',
            icon: 'AlertCircleIcon',
            variant: 'danger',
            text: 'Failed to load forms',
          },
        });
      } finally {
        this.request = false;
      }
    },

    updatePermissionsFromCurrentFields(currentFields) {
      this.myObj.forEach((group) => {
        const matchingGroup = currentFields.find((curr) => curr.id === group.id);
        if (matchingGroup) {
          group.children.forEach((child) => {
            const matchingChild = matchingGroup.children.find((curr) => curr.route === child.route);
            if (matchingChild) {
              child.view = matchingChild.view;
              child.add = matchingChild.add;
              child.edit = matchingChild.edit;
              child.delete = matchingChild.delete;
            }
          });
        }
      });

      // Update "Select All" checkboxes based on permissions
      this.myObj.forEach((group) => {
        group.children.forEach((child) => {
          if (child.view) this.all.view = true;
          if (child.add) this.all.add = true;
          if (child.edit) this.all.edit = true;
          if (child.delete) this.all.delete = true;
        });
      });
    },

    ToggleAll(name) {
      this.myObj.forEach((groups) => {
        groups.children.forEach((forms) => {
          if (name == 'view') forms.view = this.all.view;
          else if (name == 'add') forms.add = this.all.add;
          else if (name == 'edit') forms.edit = this.all.edit;
          else if (name == 'delete') forms.delete = this.all.delete;
        });
      });
    },

    CheckRoleName() {
      var elem = this.$refs['name'];
      if (this.roleObj.name == '') {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },

    async save() {
      this.CheckRoleName();
      if (this.CheckRoleName() == false) {
        return this.$bvToast.toast('Please enter the role.', {
          title: 'Error!',
          variant: 'danger',
          toaster: 'b-toaster-top-center',
        });
      }

      try {
        this.request = true;
        let newTabs = [];

        // Create a deep copy of the data structure
        let fData = JSON.parse(JSON.stringify(this.myObj));

        fData.forEach((item) => {
          let itemChildren = [];

          item.children.forEach((el) => {
            let elCopy = { ...el };
            if (elCopy.route != null) {
              elCopy.route = elCopy.route.replace('\n', '');
            }
            if (elCopy.view || elCopy.add || elCopy.edit || elCopy.delete || elCopy.permission) {
              itemChildren.push(elCopy);
            }
          });

          let newItem = {
            ...item,
            children: itemChildren,
          };

          if (itemChildren.length > 0) {
            newTabs.push(newItem);
          }
        });

        if (newTabs.length == 0) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error',
              icon: 'AlertCircleIcon',
              variant: 'danger',
              text: 'No permissions selected',
            },
          });
          return;
        }

        this.roleObj.forms = JSON.stringify(newTabs);
        this.roleObj.businessID = this.businessID;

        await APIService.save(RESOURCES.ROLES, this.roleObj, this.businessID, this.userID);

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Success',
            icon: 'CheckIcon',
            variant: 'success',
            text: this.roleObj.id ? 'Role updated successfully' : 'Role saved successfully',
          },
        });

        // Reset form state before emitting saved event
        this.resetForm();
        this.resetCheckboxes();

        // Emit saved event to parent
        this.$emit('saved');
        this.$bvModal.hide('modal-roles');
      } catch (error) {
        console.error('Error saving role:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error',
            icon: 'AlertCircleIcon',
            variant: 'danger',
            text: 'Failed to save role',
          },
        });
      } finally {
        this.request = false;
      }
    },

    closeModal() {
      this.$bvModal.hide('modal-roles');
      this.$emit('close');
    },
  },
  mounted() {
    this.loadFormData();
  },
};
</script>

<style lang="scss" scoped>
.scrollContent {
  max-height: 50vh;
  overflow-y: scroll;
}
</style>
